// The 3D printing process pages and the materials guide, rendered by
// src/components/PrintingProcessPage.js. gatsby-config.js reads the reviewed
// dates for the sitemap and lib/uv-printing-guide-canonical.js drops the
// legacy duplicate canonical on these paths.
const largeScale = require('./large-scale')
const fullColor = require('./full-color')
const sla = require('./sla')
const metal = require('./metal')
const custom = require('./custom')
const materials = require('./materials')

// Order of the "other ways we 3D print" cards.
const processPages = [largeScale, sla, fullColor, metal, custom, materials]

module.exports = {
  processPages,
  largeScale,
  fullColor,
  sla,
  metal,
  custom,
  materials,
}
